<div class="user-area-wrapper">
  <opac-user-title [title]="'user.devices.title' | translateByCustomerType: customerType.dbValue"></opac-user-title>

  <div class="user-active-devices">
    <p class="devices-hint" [tabIndex]="0">{{ devicesDescription }}</p>

    <div class="devices-list">
      <div class="devices-list__item" *ngFor="let device of activeDevices">
        <app-svg-image [type]="device.type"></app-svg-image>
        <p class="devices-list__item__title" [tabIndex]="0">{{ device.deviceName }}</p>
        <p class="devices-list__item__subtitle" [tabIndex]="0">{{ device.deviceModel }}</p>
        <span class="devices-list__item__status">{{ 'user.devices.activated' | translate }}</span>
        <p
          class="devices-list__item__date"
          [tabIndex]="0"
          [attr.aria-label]="
            ('user.devices.activated' | translate) +
            ' ' +
            (device.modificationDate | date) +
            ' - ' +
            (device.modificationDate | date: 'shortTime')
          ">
          {{ device.modificationDate | date }} - {{ device.modificationDate | date: 'shortTime' }}
        </p>
        <span class="devices-list__item__button" [opacTooltip]="hints.get(device.deviceId) | translate">
          <button
            mat-flat-button
            class="warn transparent"
            [disabled]="device.deviceId === currentDeviceId"
            (click)="deactivate(device)">
            {{ 'user.devices.deactivate' | translate }}
          </button>
        </span>
      </div>

      <div class="devices-list__item empty" *ngFor="let i of [].constructor(devicesLeft)">
        <span class="devices-list__item__type phone"></span>
        <p class="devices-list__item__title"></p>
        <p class="devices-list__item__subtitle"></p>
        <span class="devices-list__item__status"></span>
        <p class="devices-list__item__date"></p>
        <span class="devices-list__item__button"></span>
      </div>
    </div>
  </div>
</div>
